import Seller from "./From/Seller";
import Source from "./From/Source";
import Customer from "./To/Customer";
import Target from "./To/Target";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import PoolList from "./Picking/PoolList";
import classNames from "classnames";
import Buttons from "./Buttons";
import List from './List';
import isEqual from "lodash-es/isEqual";
import {connect} from "src/store";
import Box from "../../../layout/Box";
import Shipping from "./Shipping";
import AccountDate from "./Invoice/Dates/AccountDate";
import StoreOrderComment from "./StoreOrderComment";
import Other from "./Other";
import context from "../../Context/context";

class ConsignmentDeliveryForm extends React.Component {
    render() {
        const componentProps = {...this.props};
        const {props, state, parent} = componentProps;
        const {hidden, labels, actionButtons} = props;
        const Editor = props.editor || BoxEditor;
        return <Fragment>
            <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
            <Editor
                theme="default"
                body={
                    props.values.id && <form onSubmit={props.handleSubmit}>
                        <div className="row form-row">
                            <div className="col-md-3">
                                <Source {...componentProps} />
                            </div>
                            <div className="col-md-3">
                                <Customer {...componentProps} />
                            </div>
                            <div className="col-md-3">
                                <Target {...componentProps} />
                            </div>
                            <AccountDate
                                {...componentProps}
                                isClearable={true}
                            />
                        </div>
                        <div className="row form-row">
                            <Shipping {...componentProps} />
                        </div>
                        <Comment {...componentProps} />
                        <StoreOrderComment {...componentProps} />
                        <PoolList {...componentProps} control={{visible: false}}/>
                        <Other {...componentProps} tag={Fragment} />
                    </form>
                }
                footer={<Fragment>
                    <Buttons {...componentProps} />
                </Fragment>}
            />
        </Fragment>;
    }
}


export default context(ConsignmentDeliveryForm, {needle: ["pos"]});